import { isServerEnvironment } from '@cash-web/shared-util-environment'

import glitterPng from '../assets/glitter.png'
import moodWebp from '../assets/mood.webp'
import shantellMartinWebp from '../assets/shantell-martin.webp'
import tortoisePng from '../assets/tortoise.png'

const isSsr = isServerEnvironment()

const preloadImage = (src: string) =>
  new Promise(resolve => {
    const img = new Image()
    img.src = src
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false)
  })

export const prefetchCardAssets = async () => {
  const backgroundImages = isSsr
    ? Promise.resolve([true, true, true, true])
    : (() => {
        return Promise.allSettled([
          preloadImage(tortoisePng),
          preloadImage(glitterPng),
          preloadImage(moodWebp),
          preloadImage(shantellMartinWebp),
        ])
      })()

  const cardComponents = Promise.allSettled([
    import(/* webpackChunkName: "BlackCard-SVGComponent" */ './card-assets/black/Black'),
    import(/* webpackChunkName: "WhiteCard-SVGComponent" */ './card-assets/white/White'),
    import(/* webpackChunkName: "PinkCard-SVGComponent" */ './card-assets/pink/Pink'),
    import(/* webpackChunkName: "GlowInTheDarkCard-SVGComponent" */ './card-assets/glow/GlowInTheDark'),
    import(/* webpackChunkName: "ChameleonMetalCard-SVGComponent" */ './card-assets/chameleon/ChameleonMetal'),
    import(/* webpackChunkName: "ChipCard-SVGComponent" */ './card-assets/Chip'),
    import(/* webpackChunkName: "BlackMetalCard-SVGComponent" */ './card-assets/blackMetal/BlackMetal'),
    import(/* webpackChunkName: "DreamCard-SVGComponent" */ './card-assets/dream/Dream'),
    import(/* webpackChunkName: "GlitterCard-SVGComponent" */ './card-assets/glitter/Glitter'),
    import(/* webpackChunkName: "MoodCard-SVGComponent" */ './card-assets/mood/Mood'),
    import(/* webpackChunkName: "TortoiseCard-SVGComponent" */ './card-assets/tortoise/Tortoise'),
    import(/* webpackChunkName: "ShantellMartinCard-SVGComponent" */ './card-assets/shantellMartin/ShantellMartin'),
    import(/* webpackChunkName: "HundredThievesCard-SVGComponent" */ './card-assets/hundredThieves/HundredThieves'),
    import(/* webpackChunkName: "HoloCard-SVGComponent" */ './card-assets/holo/Holo'),
    import(/* webpackChunkName: "BratCard-SVGComponent" */ './card-assets/brat/Brat'),
  ])

  await Promise.allSettled([backgroundImages, cardComponents])
}
